import { ConfigHeader, FusionEntity, ProjectModel, User } from '@shared';

export interface WorkspaceModel {
	workFileId: string;
	workspaceName: string;
	projects: ProjectModel[];
	fusionEntities: FusionEntity[];
	importedUnix: number;
	fussionConfigHeaders: ConfigHeader[];
	fusionUsers: User[];
	archived: boolean;
	pendingDelete: boolean;
	importedFromFile: boolean;
	apiConnectionId?: string;
}
